import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { clearSession, getUserId, hasValidSession } from '../auth/session';
import { setUserId } from "../redux/userSlice";

// Gate for pages that require a signed-in guest. The token's own expiry is the
// authority; the request header is attached by axiosInstance, so there is no
// global axios default to keep in sync here.
const useAuth = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!hasValidSession()) {
      clearSession();
      navigate('/');
      return;
    }

    dispatch(setUserId(getUserId()));
  }, [dispatch, navigate]);
};

export default useAuth;
